module.exports = __webpack_public_path__ + "static/img/medal1.1287844.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/3/medal1.png
// module id = 1Gzo
// module chunks = 1